import {SideNavContent} from 'quickstart/components/layout/SideNav/styles'
import styled, {
  SystemProps,
  breakpoints,
  css,
  system,
  th,
} from 'quickstart/styled-components/system'

export const Divider = styled.hr<SystemProps>`
  margin: 0;
  ${th('dividers')};
  ${breakpoints({
    lg: css`
      ${SideNavContent} & {
        display: none;
      }
    `,
  })};
  ${system};
`
